module.exports = __webpack_public_path__ + "img/abt.1dda4993.jpg";